import ScreenFlaggedAdList from 'screens/FlaggedAd/List';
import ScreenFlaggedAdDetails from 'screens/FlaggedAd/Details';
import { FLAGGED_ADS } from 'routes/paths';

const flaggedAdsRoutes = [
  {
    path: FLAGGED_ADS.LIST,
    name: 'flagged_ads_list',
    component: ScreenFlaggedAdList,
    loginRequired: true,
    allowPermissions: ['view_adflag'],
  },
  {
    path: FLAGGED_ADS.DETAILS,
    name: 'flagged_ads_details',
    component: ScreenFlaggedAdDetails,
    loginRequired: true,
    allowPermissions: ['view_adflag'],
  },
];

export default flaggedAdsRoutes;
